import styled from 'styled-components';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  width: '100%',
  height: size.units(7),

  padding: `${size.units(1)} ${size.units(2)}`,

  display: 'flex',
  gap: size.units(1),
  overflow: 'hidden',

  pointerEvents: 'none',
}));
